import { dateTime } from "@/lib/fmt";
import { useEffect, useState } from "react";
import { Download, ExternalLink, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const B = process.env.REACT_APP_BACKEND_URL;

function Doc({ iid, fid, n }) {
  const [link, setLink] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get(`/inv/invoices/${iid}/files/${fid}/link`).then((r) => setLink(r.data)).catch((e) => setErr(errMsg(e))); }, [iid, fid]);
  if (err) return <div className="text-xs text-rose-700">{err}</div>;
  if (!link) return <div className="h-40 flex items-center justify-center"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  const url = `${B}${link.url}`;
  return (
    <div className="space-y-1" data-testid={`invoice-doc-${n}`}>
      {link.content_type === "application/pdf" ? <iframe title={`Invoice page ${n + 1}`} src={url} className="w-full h-[70vh] rounded border bg-white hidden md:block" />
        : <img src={url} alt={`Invoice page ${n + 1}`} className="w-full rounded border bg-white" />}
      <div className="flex gap-3 text-xs"><a className="underline flex items-center gap-1" href={url} target="_blank" rel="noreferrer" data-testid={`invoice-doc-open-${n}`}><ExternalLink className="h-3 w-3" />Open</a>
        <a className="underline flex items-center gap-1" href={`${url}?download=1`} data-testid={`invoice-doc-download-${n}`}><Download className="h-3 w-3" />Download {link.name || ""}</a></div>
    </div>
  );
}

export function InvoiceDocs({ inv }) {
  if (!inv.doc_ids?.length) return null;
  return <div className="card-surface p-3 space-y-4 lg:sticky lg:top-20" data-testid="invoice-original">{inv.doc_ids.map((f, i) => <Doc key={f} iid={inv.id} fid={f} n={i} />)}</div>;
}

const fmt = (v) => (v == null ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));

export function InvoiceAudit({ history }) {
  return (
    <div className="card-surface divide-y text-xs" data-testid="invoice-audit">{[...(history || [])].reverse().map((x, i) => (
      <div key={i} className="p-2.5">
        <div><b className="capitalize">{x.action.replace(/_/g, " ")}</b> · {x.by} · {dateTime(x.at)}</div>
        {x.reason && <div className="text-stone-600">Reason: {x.reason}</div>}
        {x.changes?.length > 0 && <ul className="mt-1 text-stone-600 space-y-0.5">{x.changes.slice(0, 12).map((c, j) => <li key={j} className="break-words">{c.line ? "Line · " : ""}{c.field.replace(/_/g, " ")}: {fmt(c.old)} → {fmt(c.new)}</li>)}{x.changes.length > 12 && <li>+{x.changes.length - 12} more</li>}</ul>}
      </div>))}
      {!history?.length && <div className="p-3 text-stone-500">No activity yet.</div>}
    </div>
  );
}
